import { useAuth } from '../stores/auth'

type Feature = 'analytics' | 'campaigns' | 'custom_branding' | 'api' | 'custom_domain' | 'multi_venue' | 'staff_unlimited'

const TIER_FEATURES: Record<string, Feature[]> = {
  starter: [],
  professional: ['analytics', 'campaigns', 'custom_branding', 'api'],
  enterprise: ['analytics', 'campaigns', 'custom_branding', 'api', 'custom_domain', 'multi_venue', 'staff_unlimited'],
}

export function useTierGate() {
  const { org } = useAuth()
  const tier = org?.subscription_tier || 'starter'

  const hasFeature = (feature: Feature) => {
    if (tier === 'enterprise') return true
    return TIER_FEATURES[tier]?.includes(feature) || false
  }

  const isTrialing = org?.subscription_status === 'trialing'

  // During trial, all features are available
  return { hasFeature: isTrialing ? () => true : hasFeature, tier, isTrialing }
}
